
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.3045',
  depVersions: {
  "customer-portal-app": "static-1.3045",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.496",
  "data-fetching-client": "static-1.9924",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.26113",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5860",
  "hs-test-utils": "static-1.8294",
  "hub-http": "static-1.6478",
  "hub-http-shared-msw-handlers": "static-1.10561",
  "hubspot-dlb": "static-2.1882",
  "hubspot-prosemirror": "static-1.18909",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11749",
  "I18n": "static-7.1666",
  "immutable": "static-2.83",
  "jasmine-runner": "static-1.6717",
  "payment-link-components": "static-1.24106",
  "portals-platform-bend-plugin": "static-1.20",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7406",
  "quartz-core": "static-1.6625",
  "quartz-i18n": "static-1.1081",
  "react": "static-7.192",
  "react-colorpicker": "static-2.10472",
  "react-dlb": "static-1.88",
  "react-utils": "static-2.5532",
  "reselect": "static-3.9",
  "rich-text-lib": "static-1.20259",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18338",
  "ui-components-test-utils": "static-1.5886",
  "UIComponents": "static-3.8695",
  "foundations-assets": "static-1.5146",
  "foundations-components": "static-1.8428",
  "foundations-theming": "static-1.4734",
  "foundations-theming-specialty": "static-1.2450",
  "framer-motion": "static-1.76",
  "metrics-js": "static-1.9867",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1377",
  "quartz-config": "static-1.1184",
  "quartz-routing": "static-1.836",
  "quick-fetch": "static-1.4108",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16980",
  "rpc-client-utils": "static-1.4928",
  "sanitize-text": "static-1.8417",
  "styled-components": "static-2.95",
  "tanstack-table": "static-1.59",
  "ui-addon-draggable": "static-3.5021",
  "ui-addon-react-router-dom": "static-1.9802",
  "usage-tracker": "static-1.7620",
  "usage-tracker-anonymous": "static-1.6037",
  "usage-tracker-core": "static-1.7470",
  "video-components-external": "static-1.12094",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "bend-plugin-trellis-migration": "static-1.3593",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3683",
  "quartz-webpack": "static-1.3630",
  "bend-plugin-quartz-routing": "static-1.484",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.86",
  "customer-data-objects": "static-1.7952",
  "frontend-preferences-client": "static-1.8190",
  "laboratory-lib": "static-3.7417",
  "onboarding-scopes": "static-1.6718",
  "seat-types-lib": "static-1.658",
  "ui-addon-opt": "static-4.8629",
  "HeadJS": "static-2.792",
  "hs-test-utils-bend-plugin": "static-1.3405",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "hs-locale-management": "static-1.269",
  "ts-schema": "static-1.4269",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8155",
  "content-media-capture": "static-1.5364",
  "cssUtils": "static-1.882",
  "customer-data-ui-utilities": "static-1.10094",
  "file-manager-components": "static-1.24406",
  "HubStyle": "static-2.12056",
  "knowledge-content-types": "static-1.8632",
  "PatternValidationJS": "static-1.3159",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.498",
  "ui-addon-emoji-picker": "static-1.10150",
  "ui-addon-i18n": "static-1.11410",
  "ui-business-units-lib": "static-1.9349",
  "ui-shepherd-react": "static-3.10531",
  "video-data-lib": "static-1.35752",
  "i18n-data": "static-1.228",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4579",
  "commerce-tours-lib": "static-1.6564",
  "customer-data-properties": "static-1.52486",
  "getting-started-shared-tasks": "static-1.19161",
  "growth-onboarding-reliability": "static-1.5345",
  "onboarding-tours": "static-1.17068",
  "reference-resolvers-lite": "static-1.8367",
  "sales-checkout-service-client": "static-1.3793",
  "ui-addon-iframeable": "static-1.9339",
  "user-context": "static-1.5381",
  "bender-build-tools": "static-1.3406",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.872",
  "hubspotter-http": "static-1.4840",
  "icons": "static-2.676",
  "mobile-manifest-mixins": "static-1.572",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.408",
  "quartz-auth": "static-1.1081",
  "quartz-head": "static-1.1071",
  "quartz-test": "static-1.1081",
  "quartz-tracking": "static-1.785",
  "trellis-components": "static-1.2556",
  "ui-fonts": "static-1.1011",
  "usage-tracker-container": "static-1.7610",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9691",
  "data-token-picker": "static-1.16839",
  "FileManagerLib": "static-1.40046",
  "property-translator": "static-1.5662",
  "atom": "static-1.5350",
  "merchandise-lib": "static-1.275",
  "purchase-motions-components": "static-1.6306",
  "salesImages": "static-1.532",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5911",
  "react-create-root-preference": "static-1.65",
  "react-select-plus": "static-1.109",
  "react-virtualized": "static-2.104",
  "ui-images": "static-2.1236",
  "bend-plugin-foundations-components": "static-1.4697",
  "floating-ui": "static-1.62",
  "react-aria": "static-1.70",
  "trellis-assets": "static-1.2537",
  "bend-plugin-foundations-theming": "static-1.3217",
  "foundations-theming-base": "static-1.3719",
  "stylex": "static-1.38",
  "interframe": "static-3.5021",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.6034",
  "opentelemetry-fe-types": "static-1.33",
  "web-vitals": "static-1.11",
  "bend-plugin-chirp-manifest": "static-1.338",
  "chirp-fetch": "static-1.2159",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4739",
  "react-flip-move": "static-1.75",
  "apollo-link-hub-http": "static-2.4920",
  "content-media-composition-data-lib": "static-1.13168",
  "content-media-compositions": "static-2.17175",
  "idb-keyval": "static-1.48",
  "immer": "static-1.94",
  "immerable": "static-1.4415",
  "magpie-lib": "static-1.5731",
  "magpie-types": "static-1.5191",
  "media-bridge-lib": "static-1.19360",
  "inbound-db-properties-service-client": "static-1.4032",
  "superstore": "static-1.5023",
  "feedback-loader": "static-1.29761",
  "ai-components-ui-library": "static-1.9639",
  "ui-addon-video-player": "static-1.8967",
  "ui-coaching-tips": "static-1.29249",
  "ContentUtils": "static-1.69063",
  "fix-webm-duration": "static-1.27",
  "notification-sounds": "static-1.4690",
  "sassPrefix": "static-1.163",
  "react-dnd-compat": "static-1.4881",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1622",
  "copilot-toolkit": "static-1.11785",
  "avatar-components": "static-1.2759",
  "navigation-messaging": "static-1.8077",
  "redux-thunk": "static-2.77",
  "reference-resolvers": "static-1.8446",
  "commerce-products-lib": "static-1.10457",
  "crm-message-bus": "static-1.43683",
  "growth-data-modal": "static-1.5846",
  "hubspot-apollo-client": "static-1.5143",
  "onboarding-tours-client": "static-1.5282",
  "batch-promise": "static-1.1807",
  "calling-global-api": "static-1.65465",
  "calling-internal-common": "static-1.31583",
  "calling-lifecycle-internal": "static-1.66847",
  "calling-lifecycle-messages": "static-1.59141",
  "conditional-properties-service-client": "static-1.3988",
  "crm-index-visualization-core": "static-1.4499",
  "crm-links": "static-1.6593",
  "crm-pipelines-api-client-types": "static-1.4324",
  "customer-data-objects-ui-components": "static-1.13295",
  "customer-data-properties-shared-msw-handlers": "static-1.9888",
  "customer-data-property-utils": "static-1.8366",
  "external-options-client-types": "static-1.4315",
  "formula-editor": "static-1.14700",
  "framework-data-schema-resolvers": "static-1.7157",
  "google-libphonenumber": "static-1.42",
  "hs-resources": "static-1.455",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbounddb-objects-service-types": "static-1.4401",
  "meetings-icalendar-utils-lib": "static-1.900",
  "multi-currency-client-types": "static-1.3885",
  "object-builder-ui-client": "static-1.49589",
  "pipeline-validation-client-types": "static-1.4158",
  "property-value-citations": "static-1.3100",
  "pulse": "static-1.891",
  "smart-data-capture-core": "static-1.65",
  "smart-property-lib": "static-1.8219",
  "tiered-pricing": "static-1.1903",
  "topics-actions-lib": "static-1.429",
  "trial-components-library": "static-1.14054",
  "ui-addon-form-validation": "static-1.11248",
  "zustand": "static-1.79",
  "growth-onboarding-confetti": "static-1.3328",
  "growth-onboarding-next-action-utils": "static-1.2632",
  "navigation-components": "static-1.18750",
  "onboarding-tours-utils": "static-1.1134",
  "ui-shepherd-tracker": "static-1.7912",
  "ui-universal-auth": "static-1.9332",
  "getting-started-shared-tasks-store": "static-1.18279",
  "opentelemetry-web": "static-1.11",
  "hubspotter-http-shared-msw-handlers": "static-1.10559",
  "usage-tracker-session-replay": "static-1.5306",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "trellis-theming": "static-1.1231",
  "tanstack-virtual": "static-1.36",
  "audio-components": "static-1.6295",
  "FileManagerCore": "static-1.39905",
  "FileManagerImages": "static-1.37557",
  "video-components": "static-1.14096",
  "foundations-components-legacy": "static-1.1453",
  "purchase-motions-api": "static-1.6309",
  "signup-constants": "static-1.19546",
  "signup-ui-url-generator": "static-2.8325",
  "usage-tracker-public": "static-1.7431",
  "reactive-lib": "static-1.985",
  "simple-logging-lib": "static-1.3314",
  "chatspot-core": "static-1.22756",
  "growth-onboarding-feedback-components": "static-1.6848",
  "cms-field-types": "static-1.5078",
  "content-icons-ui": "static-1.2328",
  "integrations-lib": "static-1.16968",
  "underscore": "static-1.8",
  "breeze-engine-chat-components": "static-1.600",
  "breeze-engine-core": "static-1.900",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.1041",
  "customer-data-tracking": "static-1.7145",
  "products-iframe-lib": "static-1.8530",
  "products-ui-components-shared-msw-handlers": "static-1.10943",
  "restore-request-side-panel-lib": "static-1.1601",
  "onboarding-data-sync-lib": "static-1.2444",
  "hubspot-apollo-cache": "static-1.602",
  "calling-error-reporting": "static-1.31590",
  "shared-worker-versioning": "static-1.11305",
  "calling-usage-tracker": "static-1.6802",
  "voice-sms-access-library": "static-1.1956",
  "conversations-skeleton-state": "static-1.7512",
  "crm-index-associations-lib": "static-1.6705",
  "framework-data-schema-quick-fetch": "static-1.7062",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10644",
  "redux-toolkit": "static-1.75",
  "sales-views-client-types": "static-1.4519",
  "location-customization-utils-lib": "static-1.10030",
  "bark-lib": "static-1.16774",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.99",
  "crm-properties-common-lib": "static-1.6153",
  "react-codemirror": "static-1.10903",
  "fdsr-migration-layer": "static-1.276",
  "framework-builder-read-service-client": "static-1.4198",
  "persist-promise": "static-1.3964",
  "event-emitter": "static-1.1219",
  "bend-plugin-pulse": "static-1.394",
  "fast-json-patch": "static-1.67",
  "data-agent-kit": "static-1.598",
  "fsm": "static-1.4008",
  "policy-lib": "static-1.7062",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10707",
  "embedded-academy-lib": "static-1.15428",
  "hubs-service-types": "static-1.1521",
  "growth-onboarding-next-action-components": "static-1.2660",
  "user-context-client": "static-1.4773",
  "nest": "static-1.501",
  "unified-auth-core-lib": "static-1.1128",
  "amplitude-session-replay-browser": "static-1.60",
  "breeze-artifacts-sdk": "static-1.239",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4798",
  "video-embed": "static-1.36586",
  "social-insights-client-types": "static-1.22685",
  "flux-actions": "static-1.363",
  "integrations-error-boundary-lib": "static-1.14383",
  "integrations-tracking-lib": "static-1.5871",
  "native-integrations-shared-strings": "static-1.8043",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10634",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.846",
  "InboxConnectUtils": "static-4.15494",
  "meetings-connect-utils-lib": "static-1.7873",
  "calling-orchestration-schema": "static-1.36733",
  "crm-record-cards-service-types": "static-1.3759",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16303",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.108",
  "trellis-story-utils": "static-1.4773",
  "storybook-react": "static-1.37",
  "academy-common-lib": "static-1.14888",
  "outpost": "static-1.4423",
  "universal-page-editor-lib": "static-1.3271",
  "adobe-sign-auth-lib": "static-1.391",
  "ads-unified-auth-lib": "static-1.1176",
  "google-sheets-integration-lib": "static-1.966",
  "microsoft-drive-auth-lib": "static-1.65",
  "surveymonkey-integration-lib": "static-1.411",
  "slack-ui-library": "static-1.10663",
  "hub-http-contrib": "static-1.3303",
  "ui-addon-sales-email": "static-1.5478",
  "academy-service-client": "static-1.3953",
  "croppie": "static-2.10",
  "final-form": "static-1.75",
  "SafeStorage": "static-1.4669",
  "trellis-ecosystem": "static-1.7584",
  "wootric-nps": "static-1.7176",
  "marketplace-ui-apps-core": "static-1.19176",
  "marketplace-ui-common": "static-1.20644",
  "developer-experience-shared-components": "static-1.10768",
  "immutable-less": "static-1.4915",
  "marketplace-ui-client-types": "static-1.18051",
  "ui-addon-integrations-directory-panel": "static-2.8290",
  "ui-extensibility-client-types": "static-1.4183",
  "ai-settings-ui-library": "static-1.8276",
  "nav-meta": "static-1.30387",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.933",
  "apps-service-types": "static-1.4005",
  "oauth-service-types": "static-1.4507",
  "simple-data-table": "static-1.3471"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.3045",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.496",
  "data-fetching-client": "/data-fetching-client/static-1.9924",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.26113",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5860",
  "hs-test-utils": "/hs-test-utils/static-1.8294",
  "hub-http": "/hub-http/static-1.6478",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10561",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18909",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11749",
  "I18n": "/I18n/static-7.1666",
  "immutable": "/immutable/static-2.83",
  "jasmine-runner": "/jasmine-runner/static-1.6717",
  "payment-link-components": "/payment-link-components/static-1.24106",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.20",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7406",
  "quartz-core": "/quartz-core/static-1.6625",
  "quartz-i18n": "/quartz-i18n/static-1.1081",
  "react": "/react/static-7.192",
  "react-colorpicker": "/react-colorpicker/static-2.10472",
  "react-dlb": "/react-dlb/static-1.88",
  "react-utils": "/react-utils/static-2.5532",
  "reselect": "/reselect/static-3.9",
  "rich-text-lib": "/rich-text-lib/static-1.20259",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18338",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5886",
  "UIComponents": "/UIComponents/static-3.8695",
  "foundations-assets": "/foundations-assets/static-1.5146",
  "foundations-components": "/foundations-components/static-1.8428",
  "foundations-theming": "/foundations-theming/static-1.4734",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2450",
  "framer-motion": "/framer-motion/static-1.76",
  "metrics-js": "/metrics-js/static-1.9867",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1377",
  "quartz-config": "/quartz-config/static-1.1184",
  "quartz-routing": "/quartz-routing/static-1.836",
  "quick-fetch": "/quick-fetch/static-1.4108",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16980",
  "rpc-client-utils": "/rpc-client-utils/static-1.4928",
  "sanitize-text": "/sanitize-text/static-1.8417",
  "styled-components": "/styled-components/static-2.95",
  "tanstack-table": "/tanstack-table/static-1.59",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5021",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9802",
  "usage-tracker": "/usage-tracker/static-1.7620",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6037",
  "usage-tracker-core": "/usage-tracker-core/static-1.7470",
  "video-components-external": "/video-components-external/static-1.12094",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3593",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3683",
  "quartz-webpack": "/quartz-webpack/static-1.3630",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.484",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.86",
  "customer-data-objects": "/customer-data-objects/static-1.7952",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8190",
  "laboratory-lib": "/laboratory-lib/static-3.7417",
  "onboarding-scopes": "/onboarding-scopes/static-1.6718",
  "seat-types-lib": "/seat-types-lib/static-1.658",
  "ui-addon-opt": "/ui-addon-opt/static-4.8629",
  "HeadJS": "/HeadJS/static-2.792",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3405",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "hs-locale-management": "/hs-locale-management/static-1.269",
  "ts-schema": "/ts-schema/static-1.4269",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8155",
  "content-media-capture": "/content-media-capture/static-1.5364",
  "cssUtils": "/cssUtils/static-1.882",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10094",
  "file-manager-components": "/file-manager-components/static-1.24406",
  "HubStyle": "/HubStyle/static-2.12056",
  "knowledge-content-types": "/knowledge-content-types/static-1.8632",
  "PatternValidationJS": "/PatternValidationJS/static-1.3159",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.498",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10150",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11410",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9349",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10531",
  "video-data-lib": "/video-data-lib/static-1.35752",
  "i18n-data": "/i18n-data/static-1.228",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4579",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6564",
  "customer-data-properties": "/customer-data-properties/static-1.52486",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19161",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5345",
  "onboarding-tours": "/onboarding-tours/static-1.17068",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8367",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3793",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9339",
  "user-context": "/user-context/static-1.5381",
  "bender-build-tools": "/bender-build-tools/static-1.3406",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.872",
  "hubspotter-http": "/hubspotter-http/static-1.4840",
  "icons": "/icons/static-2.676",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.572",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.408",
  "quartz-auth": "/quartz-auth/static-1.1081",
  "quartz-head": "/quartz-head/static-1.1071",
  "quartz-test": "/quartz-test/static-1.1081",
  "quartz-tracking": "/quartz-tracking/static-1.785",
  "trellis-components": "/trellis-components/static-1.2556",
  "ui-fonts": "/ui-fonts/static-1.1011",
  "usage-tracker-container": "/usage-tracker-container/static-1.7610",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9691",
  "data-token-picker": "/data-token-picker/static-1.16839",
  "FileManagerLib": "/FileManagerLib/static-1.40046",
  "property-translator": "/property-translator/static-1.5662",
  "atom": "/atom/static-1.5350",
  "merchandise-lib": "/merchandise-lib/static-1.275",
  "purchase-motions-components": "/purchase-motions-components/static-1.6306",
  "salesImages": "/salesImages/static-1.532",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5911",
  "react-create-root-preference": "/react-create-root-preference/static-1.65",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-virtualized": "/react-virtualized/static-2.104",
  "ui-images": "/ui-images/static-2.1236",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4697",
  "floating-ui": "/floating-ui/static-1.62",
  "react-aria": "/react-aria/static-1.70",
  "trellis-assets": "/trellis-assets/static-1.2537",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3217",
  "foundations-theming-base": "/foundations-theming-base/static-1.3719",
  "stylex": "/stylex/static-1.38",
  "interframe": "/interframe/static-3.5021",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6034",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.33",
  "web-vitals": "/web-vitals/static-1.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.338",
  "chirp-fetch": "/chirp-fetch/static-1.2159",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4739",
  "react-flip-move": "/react-flip-move/static-1.75",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4920",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13168",
  "content-media-compositions": "/content-media-compositions/static-2.17175",
  "idb-keyval": "/idb-keyval/static-1.48",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4415",
  "magpie-lib": "/magpie-lib/static-1.5731",
  "magpie-types": "/magpie-types/static-1.5191",
  "media-bridge-lib": "/media-bridge-lib/static-1.19360",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4032",
  "superstore": "/superstore/static-1.5023",
  "feedback-loader": "/feedback-loader/static-1.29761",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9639",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8967",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29249",
  "ContentUtils": "/ContentUtils/static-1.69063",
  "fix-webm-duration": "/fix-webm-duration/static-1.27",
  "notification-sounds": "/notification-sounds/static-1.4690",
  "sassPrefix": "/sassPrefix/static-1.163",
  "react-dnd-compat": "/react-dnd-compat/static-1.4881",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1622",
  "copilot-toolkit": "/copilot-toolkit/static-1.11785",
  "avatar-components": "/avatar-components/static-1.2759",
  "navigation-messaging": "/navigation-messaging/static-1.8077",
  "redux-thunk": "/redux-thunk/static-2.77",
  "reference-resolvers": "/reference-resolvers/static-1.8446",
  "commerce-products-lib": "/commerce-products-lib/static-1.10457",
  "crm-message-bus": "/crm-message-bus/static-1.43683",
  "growth-data-modal": "/growth-data-modal/static-1.5846",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5143",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5282",
  "batch-promise": "/batch-promise/static-1.1807",
  "calling-global-api": "/calling-global-api/static-1.65465",
  "calling-internal-common": "/calling-internal-common/static-1.31583",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66847",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59141",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3988",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4499",
  "crm-links": "/crm-links/static-1.6593",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4324",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13295",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9888",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8366",
  "external-options-client-types": "/external-options-client-types/static-1.4315",
  "formula-editor": "/formula-editor/static-1.14700",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7157",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "hs-resources": "/hs-resources/static-1.455",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4401",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.900",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3885",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49589",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4158",
  "property-value-citations": "/property-value-citations/static-1.3100",
  "pulse": "/pulse/static-1.891",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.65",
  "smart-property-lib": "/smart-property-lib/static-1.8219",
  "tiered-pricing": "/tiered-pricing/static-1.1903",
  "topics-actions-lib": "/topics-actions-lib/static-1.429",
  "trial-components-library": "/trial-components-library/static-1.14054",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11248",
  "zustand": "/zustand/static-1.79",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3328",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2632",
  "navigation-components": "/navigation-components/static-1.18750",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1134",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7912",
  "ui-universal-auth": "/ui-universal-auth/static-1.9332",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18279",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10559",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5306",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "trellis-theming": "/trellis-theming/static-1.1231",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "audio-components": "/audio-components/static-1.6295",
  "FileManagerCore": "/FileManagerCore/static-1.39905",
  "FileManagerImages": "/FileManagerImages/static-1.37557",
  "video-components": "/video-components/static-1.14096",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1453",
  "purchase-motions-api": "/purchase-motions-api/static-1.6309",
  "signup-constants": "/signup-constants/static-1.19546",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8325",
  "usage-tracker-public": "/usage-tracker-public/static-1.7431",
  "reactive-lib": "/reactive-lib/static-1.985",
  "simple-logging-lib": "/simple-logging-lib/static-1.3314",
  "chatspot-core": "/chatspot-core/static-1.22756",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6848",
  "cms-field-types": "/cms-field-types/static-1.5078",
  "content-icons-ui": "/content-icons-ui/static-1.2328",
  "integrations-lib": "/integrations-lib/static-1.16968",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.600",
  "breeze-engine-core": "/breeze-engine-core/static-1.900",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.1041",
  "customer-data-tracking": "/customer-data-tracking/static-1.7145",
  "products-iframe-lib": "/products-iframe-lib/static-1.8530",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10943",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1601",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2444",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.602",
  "calling-error-reporting": "/calling-error-reporting/static-1.31590",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11305",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6802",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1956",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7512",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6705",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7062",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10644",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "sales-views-client-types": "/sales-views-client-types/static-1.4519",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10030",
  "bark-lib": "/bark-lib/static-1.16774",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.99",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6153",
  "react-codemirror": "/react-codemirror/static-1.10903",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.276",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4198",
  "persist-promise": "/persist-promise/static-1.3964",
  "event-emitter": "/event-emitter/static-1.1219",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.394",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "data-agent-kit": "/data-agent-kit/static-1.598",
  "fsm": "/fsm/static-1.4008",
  "policy-lib": "/policy-lib/static-1.7062",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10707",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15428",
  "hubs-service-types": "/hubs-service-types/static-1.1521",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2660",
  "user-context-client": "/user-context-client/static-1.4773",
  "nest": "/nest/static-1.501",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1128",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.239",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4798",
  "video-embed": "/video-embed/static-1.36586",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "flux-actions": "/flux-actions/static-1.363",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14383",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5871",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8043",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10634",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.846",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15494",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7873",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36733",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3759",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16303",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.108",
  "trellis-story-utils": "/trellis-story-utils/static-1.4773",
  "storybook-react": "/storybook-react/static-1.37",
  "academy-common-lib": "/academy-common-lib/static-1.14888",
  "outpost": "/outpost/static-1.4423",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3271",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.391",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1176",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.966",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.65",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.411",
  "slack-ui-library": "/slack-ui-library/static-1.10663",
  "hub-http-contrib": "/hub-http-contrib/static-1.3303",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5478",
  "academy-service-client": "/academy-service-client/static-1.3953",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.75",
  "SafeStorage": "/SafeStorage/static-1.4669",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7584",
  "wootric-nps": "/wootric-nps/static-1.7176",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19176",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20644",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10768",
  "immutable-less": "/immutable-less/static-1.4915",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18051",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8290",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4183",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8276",
  "nav-meta": "/nav-meta/static-1.30387",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.933",
  "apps-service-types": "/apps-service-types/static-1.4005",
  "oauth-service-types": "/oauth-service-types/static-1.4507",
  "simple-data-table": "/simple-data-table/static-1.3471"
}
};
